import { useEffect } from 'react';
import { useLocation } from 'react-router';
import { useAnalyticsContext } from './useAnalyticsContext';

/**
 * useAnalyticsPageView logs the pages viewed by the user
 * @param requireLoggedIn log events only if the user is logged in
 */
export const useAnalyticsPageView = (requireLoggedIn?: boolean) => {
  const location = useLocation();
  const { loggedIn, pageView } = useAnalyticsContext();

  const logPageView = async () => {
    try {
      await pageView(
        {
          Url: window.location.toString(),
          Path: location.pathname,
          Host: window.location.hostname,
          Title: document.title,
          Search: window.location.search
        },
        requireLoggedIn
      );
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error(error);
    }
  };

  useEffect(() => {
    if (!requireLoggedIn || (requireLoggedIn && loggedIn)) {
      logPageView();
    }
  }, [location.pathname, loggedIn]);
};
